import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromStopLicense from './reducers/stop-license.reducer';
import { EffectsModule } from '@ngrx/effects';
import { StopLicenseEffects } from './effects/stop-license.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('stopLicense', fromStopLicense.reducer),
    EffectsModule.forFeature([StopLicenseEffects])
  ]
})
export class StopLicenseModule { }
